import ComponentView from './ComponentView';
import './ComponentView.scss';

export default ComponentView;
